<template>
  <div id="app">
    <Loader />
    <router-view/>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
export default {
  components: {Loader}
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Poppins:200,300,400,500,600,700,800,900');
@import url('https://fonts.googleapis.com/css?family=Raleway:400,500,600,700,800');

body, html {
  font-family: Poppins-Regular, sans-serif;
  font-size: 14px;
  color: #333;
  background: #f2f2f2;
  height: 100vh;
  overflow-y: auto; /* Allow vertical scrolling */
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
}

p {
  margin: 0;
}

ul, li {
  margin: 0;
  list-style-type: none;
}

input {
  outline: none;
  border: none;
}

textarea {
  outline: none;
  border: none;
}

button {
  outline: none;
  border: none;
  background: transparent;
}

input:focus, textarea:focus, select:focus, button:focus {
  outline: none;
}

input::-webkit-input-placeholder { color: #999; }
input:-moz-placeholder { color: #999; }
input::-moz-placeholder { color: #999; }
input:-ms-input-placeholder { color: #999; }
textarea::-webkit-input-placeholder { color: #999; }
textarea:-moz-placeholder { color: #999; }
textarea::-moz-placeholder { color: #999; }
textarea:-ms-input-placeholder { color: #999; }

.limiter {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
}

.container-login100 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap-login100 {
  margin: 0 1px;
  width: 100%;
  max-width: 600px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.image {
  padding-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 25px;
}

.image img {
  max-width: 14%;
  height: auto;
  display: block;
}


/* Media Queries */
@media (max-width: 768px) {
  .image img{
    max-width: 30%;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .image {
    margin-bottom: 10px;
  }
}
.login100-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login100-form-title {
  font-size: 26px;
  color: #666666;
  text-align: center;
  display: block;
  line-height: 1.2;
  margin-top: 10px;
  margin-bottom: 20px;
}

.input100 {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 14px;
  box-sizing: border-box;
}

.input100:focus + .focus-input100 {
  -webkit-animation: anim-shadow 0.5s ease-in-out forwards;
  animation: anim-shadow 0.5s ease-in-out forwards;
}

.input100:focus + .focus-input100 + .symbol-input100 {
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(67, 183, 37, 0.5);
}

.file-input-container {
  position: relative;
}

input[type="file"] {
  display: none;
}
.btn-file-input {
  min-width: 250px; /* Minimum width for select input */
  display: block;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #fff;
  text-align: center;
}

.login100-form-btn {
  width: 48%;
  padding: 10px;
  border-radius: 5px;
  border: none;
  background: #3A6898;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
}
.login100-form-btn:hover {
  transform: scale(1.05);
}
select.input100 {
  /* Add these styles to make the select input look consistent */
  outline: none;
  color: #333;
  line-height: 1.2;
  width: 100%;
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 15px;
  width: 100%;
}

.form-group label {
  font-family: Poppins-Medium;
  font-size: 15px;
  color: #333;
  display: block;
  margin-bottom: 5px;
}

.file-input-container {
  position: relative;
}

.file-input-container label {
  display: block;
  font-size: 14px;
  color: #333;
}

.file-input-container label {
  background: #e6e6e6;
  color: #666;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.4s;
}

.form-navigation {
  display: flex;
  justify-content: space-between;
}

.form-navigation .login100-form-btn {
  margin: 0;
}

.btn-location {
  margin: 1rem;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: white;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
}

.btn-location:hover {
  transform: scale(1.05);
}

.instructions {
  position: absolute;
  top: 10px; /* Position above the image */
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  max-width: 90%;
}
.step-indicator {
  display: flex;
  justify-content: space-between; /* Adjust spacing */
  align-items: center;
}

.step {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ddd;
  margin: 0 10px; /* Adjust spacing as needed */
  transition: background-color 0.3s ease;
}

.step.active {
  background-color: #4caf50; /* Active step color */
}
.form-summary {
  display: block;
}

.form-group {
  flex: 1 1 calc(50% - 20px); /* Adjust width to fit 2 items per row minus the gap */
  box-sizing: border-box;
}

.summary-item {
  font-size: 16px; /* Adjust the font size as needed */
  color: #666666; /* Set the text color */
  margin: 5px 0; /* Adjust margin for spacing */
}

.summary-item strong {
  font-weight: bold;
}

</style>
